import { ROUTES } from '@/constants/routes';
import { useNavigate } from 'react-router-dom';
import { CustomerListItem } from '@/types/customers';
import { formatCurrency } from '@/utils/currency';
import { SVListItemCard } from '../core';

type CustomersListProps = {
  customers: CustomerListItem[];
};

export default function CustomersList({ customers }: CustomersListProps) {
  const navigate = useNavigate();

  return (
    <>
      {customers.map(customers => {
        const {
          uuid,
          avatar,
          status,
          email,
          firstName,
          lastName,
          aggregateInfo,
          company,
        } = customers;
        const ownerName = `${firstName} ${lastName}`;

        return (
          <SVListItemCard
            onClick={() => navigate(`${ROUTES.CUSTOMERS}/${uuid}`)}
            avatar={avatar}
            showAvatar
            key={uuid}
            header={ownerName}
            status={status}
            statusType="standard"
            manageMenuItems={[
              {
                label: 'Edit',
                onClick: () =>
                  navigate(`${ROUTES.CUSTOMERS_EDIT_PARAMS}/${uuid}`),
              },
              {
                label: 'Applications',
                onClick: () =>
                  navigate(
                    `${ROUTES.BANK_ACCOUNT_APPLICATIONS}?ownerName=${ownerName}`,
                  ),
              },
              {
                label: 'External Accounts',
                onClick: () =>
                  navigate(
                    `${ROUTES.CUSTOMERS}/${uuid}${ROUTES.EXTERNAL_ACCOUNTS}`,
                  ),
              },
              {
                label: 'Wire Recipients',
                onClick: () =>
                  navigate(
                    `${ROUTES.CUSTOMERS}/${uuid}${ROUTES.WIRE_RECIPIENTS}`,
                  ),
              },
            ]}
            additionalInfo={[
              {
                label: 'Email',
                text: email,
              },
              {
                label: 'Company',
                text: company.name,
              },
              {
                label: 'Active Bank Accounts',
                text: aggregateInfo.totalActiveBankAccounts,
              },
              {
                label: 'Total Available Balance',
                text: formatCurrency({
                  amount: aggregateInfo.totalAvailableBalance.value,
                }),
              },
            ]}
          />
        );
      })}
    </>
  );
}
